import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import i18n from '../../../translations/i18n';
import { Chip, Stack } from '@mui/material';
import { Client, JobFunction } from '../../../api/contactsApi/interfaces';
import { AgentBadge } from '../../../components/AgentBadge';
import { DateCell } from '../../../components/data-table';

export const columns: GridColDef[] = [
  {
    field: 'firstName',
    headerName: i18n.t('entities:common.firstName'),
    width: 130,
    hideable: false,
  },
  {
    field: 'lastName',
    headerName: i18n.t('entities:common.lastName'),
    width: 130,
    valueGetter: (value) => value || '-',
    hideable: false,
  },
  {
    field: 'jobFunctions',
    headerName: i18n.t('entities:contact.jobFunction'),
    width: 300,
    renderCell: (params) => {
      const row = params.row;

      return (
        <Stack
          alignItems="center"
          direction="row"
          gap="5px"
          sx={{ height: '100%' }}
        >
          {!row.jobFunctions.length && '-'}
          {row.jobFunctions &&
            row.jobFunctions.map((jobFunction: JobFunction) => (
              <Chip
                size="small"
                key={jobFunction.id}
                label={jobFunction.name}
              />
            ))}
        </Stack>
      );
    },
  },
  {
    field: 'email',
    headerName: i18n.t('entities:common.email'),
    width: 250,
    valueGetter: (value) => value || '-',
  },
  {
    field: 'phonenumber',
    headerName: i18n.t('entities:contact.phonenumber'),
    width: 180,
    valueGetter: (value) => value || '-',
  },
  {
    field: 'contactInterval',
    headerName: i18n.t('entities:contact.contactInterval'),
    width: 130,
    valueGetter: (params) => {
      return params ? i18n.t('words.month', { count: params / 30 }) : '-';
    },
  },
  {
    field: 'clients',
    headerName: i18n.t('entities:contact.clients'),
    width: 300,
    renderCell: (params) => {
      const row = params.row;

      return (
        <Stack
          alignItems="center"
          direction="row"
          gap="5px"
          sx={{ height: '100%' }}
        >
          {!row.clients.length && '-'}
          {row.clients &&
            row.clients.map((client: Client) => (
              <Chip size="small" key={client.id} label={client.name} />
            ))}
        </Stack>
      );
    },
  },
  {
    field: 'createdBy',
    headerName: i18n.t('entities:common.createdBy'),
    filterable: false,
    minWidth: 160,
    flex: 1,
    renderCell: (params) => {
      const row = params.row;

      return <AgentBadge agent={row.createdBy} />;
    },
  },
  {
    field: 'createdAt',
    headerName: i18n.t('entities:common.createdAt'),
    filterable: false,
    minWidth: 160,
    flex: 1,
    renderCell: (params) => {
      const row = params.row;

      return <DateCell date={row.createdAt} />;
    },
  },
];
